import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
const CHECKOUT_URL = 'https://l.instagram.com/?u=http%3A%2F%2Fwa.me%2F17868671817%3Futm_source%3Dig%26utm_medium%3Dsocial%26utm_content%3Dlink_in_bio%26fbclid%3DPAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGnaqJ2Sof8kfKpMO62ETPquQzMk-2f5LDvIZ9MIKBRalOfvG9MYpFuYb5DDDE_aem_l3V7ISs1CoqqMmsUrca1pg&e=AT7ythc19Xwk1ZxDZqn7pj_Ell9adPiCk2-P9fqK616cnbmjzxEBcJ8ATXaG_tA4TMS_dwYUCoaPw3TvwftFSgyJXyIwu7Nn4YUvG2aIPQ';
interface MeetCindyProps {
  onBookClick: () => void;
}
export function MeetCindy({
  onBookClick
}: MeetCindyProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start']
  });
  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  const imageY = useTransform(smoothProgress, [0, 1], ['-8%', '8%']);
  const imageScale = useTransform(smoothProgress, [0, 0.5], [1.15, 1]);
  const imageOpacity = useTransform(smoothProgress, [0, 0.3], [0, 1]);
  const textY = useTransform(smoothProgress, [0, 1], ['8%', '-8%']);
  const textOpacity = useTransform(smoothProgress, [0.1, 0.4], [0, 1]);
  const lineWidth = useTransform(smoothProgress, [0.2, 0.5], ['0%', '100%']);
  return <section ref={containerRef} className="py-24 md:py-40 bg-ivory-dark overflow-hidden relative" data-id="element-103">
      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-104">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24 items-center" data-id="element-105">
          {/* Image Side */}
          <div className="relative" data-id="element-106">
            <motion.div style={{
            y: imageY,
            scale: imageScale,
            opacity: imageOpacity
          }} className="relative aspect-[4/5] md:aspect-square rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(197,165,114,0.15)]" data-id="element-107">
              <img src="https://cdn.magicpatterns.com/uploads/rppXmZ9X8YnKPTgNEuPi7r/Screenshot_2026-02-15_at_5.49.37_PM.png" alt="Cindy Salloum Echeto" className="w-full h-full object-cover" data-id="element-108" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none" data-id="element-109" />
            </motion.div>

            <motion.div style={{
            y: useTransform(smoothProgress, [0, 1], ['-4%', '4%'])
          }} className="absolute inset-4 border border-white/40 rounded-xl pointer-events-none z-20" data-id="element-110" />
          </div>

          {/* Text Side */}
          <motion.div style={{
          y: textY,
          opacity: textOpacity
        }} className="flex flex-col justify-center relative" data-id="element-111">
            <div className="mb-6 overflow-hidden" data-id="element-112">
              <motion.div style={{
              width: lineWidth
            }} className="h-[1px] bg-gold mb-4 max-w-[100px]" data-id="element-113" />
              <span className="text-gold text-sm font-medium tracking-widest uppercase block" data-id="element-114">
                Esteticista Profesional
              </span>
            </div>

            <h2 className="text-4xl md:text-6xl font-serif text-softBlack mb-8 leading-tight" data-id="element-115">
              Conoce a Cindy
            </h2>

            <div className="space-y-6 text-warmGray text-lg leading-relaxed font-light" data-id="element-116">
              <p data-id="element-117">
                Con dedicación y pasión por el cuidado de la piel, Cindy Salloum
                Echeto ha creado un espacio donde la belleza se encuentra con la
                calma.
              </p>
              <p data-id="element-118">
                Su enfoque profesional y cercano transforma cada visita en una
                experiencia de confianza y bienestar, priorizando siempre la
                salud de tu piel por encima de tendencias pasajeras.
              </p>
            </div>

            <div className="mt-10" data-id="element-119">
              <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="group relative inline-block px-8 py-3 bg-transparent overflow-hidden rounded-full transition-all duration-300" data-id="element-120">
                <span className="absolute inset-0 border border-gold rounded-full group-hover:bg-gold transition-all duration-300" data-id="element-121"></span>
                <span className="relative text-gold group-hover:text-white text-sm font-medium transition-colors duration-300" data-id="element-122">
                  Agendar cita
                </span>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}